import $ from 'jquery';

export default class AccordionModule {

    constructor(root)
    {
        this.container = root;
        this.accordionTabs = $('.accordion-module .entry').has('.btf-text');

        this.accordionTabs.unbind('click');
        this.accordionTabs.click(function (e) {
            // In the sustainability calculator, the accordion module is used to display a set of form fields
            // that will be clicked in, and shouldn't collapse the accordion.
            if ($(this).find('.calculator__field--group').length && $(e.target).closest('.title-section').length === 0) {
                return;
            }
            $(this).toggleClass('expanded');

            if (window.innerWidth > 768) {
                $(this).find('.btf-text, .cta-ctnr').slideToggle(300);
            } else {
                $(this).find('.atf-text, .btf-text, .cta-ctnr').slideToggle(300);
            }
        });

        $(window).resize(() => {
            this.handleResize();
        });

        this.handleResize();
    }

    handleResize()
    {
        if (window.innerWidth > 768) {
            $('.atf-text').slideDown(0);
        } else {
            $('.entry:not(.expanded) .atf-text').slideUp(0);
        }
    }
}
